'use client';
import { useState } from 'react';
import { CreditBox } from 'components/UI/Creditbox/Creditbox';
import type { VideoEmbedType } from 'components/UI/FoundationPlayer';
import FoundationPlayer from 'components/UI/FoundationPlayer/FoundationPlayer';
import VideoSwiper from 'components/UI/VideoSwiper/VideoSwiper';
import type { VideoProps } from 'types/videoTypes';
import { getVideoEmbedType } from 'utils/videoPlayer';
import styles from './with-related.module.scss';

export const WidgetVideoWithRelated = ({
  context,
  customPlayButton,
  index,
  embedType,
}: {
  context: VideoProps;
  customPlayButton?: boolean;
  index?: number;
  embedType?: VideoEmbedType;
}) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(-1);
  const [showRelatedVideos, setShowRelatedVideos] = useState<boolean>(false);
  const [isAdPlaying, setIsAdPlaying] = useState<boolean>(false);
  const { related = [], ...video } = context;
  const [videoPlaying, setVideoPlaying] = useState<boolean>(false);
  const [isAutoplay, setIsAutoplay] = useState<boolean>(false);
  const [showCustomPlayButton, setShowCustomPlayButton] = useState<boolean>(customPlayButton ?? false);
  const [currentStartType, setCurrentStartType] = useState<number>(0);

  const currentVideo = currentVideoIndex === -1 ? video : related[currentVideoIndex];

  const triggerNextItem = () => {
    if (currentVideoIndex >= 0 && currentVideoIndex < related.length) {
      setCurrentStartType(1);
      setIsAutoplay(true);
      setCurrentVideoIndex(currentVideoIndex + 1);
    }
  };

  return (
    <div className={styles.main} data-testid="video-player">
      <FoundationPlayer
        video={currentVideo}
        postRollDisabled
        showRelatedVideosListener={setShowRelatedVideos}
        isAdPlayingListener={setIsAdPlaying}
        videoPlayingListener={setVideoPlaying}
        contentFinishedListener={triggerNextItem}
        customPlayButton={showCustomPlayButton}
        startType={currentStartType}
        autoplay={isAutoplay}
        embedType={embedType ?? getVideoEmbedType(index)}
      />

      <CreditBox video={currentVideo} />
      {related.length > 0 && (
        <VideoSwiper
          onClick={(index: number) => {
            setCurrentStartType(2);
            setIsAutoplay(true);
            setShowCustomPlayButton(false);
            setCurrentVideoIndex(index);
          }}
          videoList={related}
          isAdPlaying={isAdPlaying}
          currentVideoIndex={currentVideoIndex}
          videoPlaying={videoPlaying}
          initHidden
          showRelatedVideos={showRelatedVideos}
          className={styles.swiperNewRoot}
        />
      )}
    </div>
  );
};
